import { memo, ReactElement, useMemo } from 'react'
import { Box } from '@mui/material'
import TruncatedText from './TruncatedText'
import { formatEntityDisplayLabel } from '../../utils/entityDisplayUtils'

interface IEntityTypeData {
    fontSize?: string
    dataValue: any
    orgId?: string
}

const EntityTypeData = ({
    fontSize,
    dataValue,
}: IEntityTypeData): ReactElement => {
    const updatedEntityValues: any = useMemo(
        () =>
            Array.isArray(dataValue) ? dataValue : !dataValue || [dataValue],
        [dataValue],
    )

    if (Array.isArray(updatedEntityValues) && updatedEntityValues.length) {
        return (
            <Box sx={{ width: '100%' }}>
                <TruncatedText
                    sx={{ fontSize: fontSize || '14px' }}
                    component="span"
                    marginTop="2px"
                    marginRight="5px"
                    text={updatedEntityValues
                        ?.map((item: any) => formatEntityDisplayLabel(item))
                        .join(', ')}
                ></TruncatedText>
            </Box>
        )
    }

    return (
        <Box sx={{ width: '100%' }}>
            <TruncatedText text="" />
        </Box>
    )
}

const MemoizedEntityTypeData = memo(EntityTypeData)
MemoizedEntityTypeData.displayName = 'EntityTypeData'
export default MemoizedEntityTypeData
